/* ECO language auto-detect + remember.
   - First open (per browser session): redirect to the visitor's browser language
     if supported, else English.
   - Explicit choice (clicking the language switcher) is saved in localStorage and
     always wins on subsequent visits.
   Requires window.ecoLoc = { current: "<iso>", map: { "<iso>": "<root_url>", ... } }. */
(function () {
  var L = window.ecoLoc;
  if (!L || !L.map) return;
  var current = L.current;
  var map = L.map;

  // base language code -> full iso key (e.g. "pt" -> "pt-PT")
  var byBase = {};
  Object.keys(map).forEach(function (code) {
    var b = code.split('-')[0].toLowerCase();
    if (!byBase[b]) byBase[b] = code;
  });

  function resolve(code) {
    if (!code) return null;
    if (map[code]) return code;
    var b = code.split('-')[0].toLowerCase();
    return byBase[b] || null;
  }

  function localizedPath(target) {
    var curRoot = map[current] || '/';
    var path = window.location.pathname;
    var base = path;
    if (curRoot !== '/' && path.indexOf(curRoot) === 0) base = path.slice(curRoot.length);
    var tRoot = map[target] || '/';
    var np = (tRoot === '/' ? '' : tRoot) + base;
    if (np === '') np = '/';
    return np + window.location.search + window.location.hash;
  }

  // Persist explicit choice (desktop switcher links + mobile localization select)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.eco-lang a[hreflang], .localization-form a[hreflang]');
    if (a) {
      var iso = a.getAttribute('hreflang');
      try { localStorage.setItem('ecoLang', iso); } catch (_) {}
      // Switch language but STAY on the current page. The link href is the language
      // root (would jump to the homepage); rewrite it to the current path in the
      // target locale so the user keeps their place.
      var t = resolve(iso);
      if (t && map[t] && t !== current) {
        e.preventDefault();
        window.location.assign(localizedPath(t));
      }
    }
  });
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (s && s.name === 'language_code') { try { localStorage.setItem('ecoLang', s.value); } catch (_) {} }
  });

  // Decide the target language
  var pref = null;
  try { pref = localStorage.getItem('ecoLang'); } catch (_) {}
  var target = resolve(pref);

  if (!target) {
    var redirected = false;
    try { redirected = sessionStorage.getItem('ecoRedir'); } catch (_) {}
    if (!redirected) {
      var langs = navigator.languages || [navigator.language || 'en'];
      for (var i = 0; i < langs.length && !target; i++) target = resolve(langs[i]);
      if (!target) target = resolve('en');   // fallback: English
    }
  }
  try { sessionStorage.setItem('ecoRedir', '1'); } catch (_) {}

  if (target && target !== current && map[target]) {
    window.location.replace(localizedPath(target));
  }
})();
